module.exports = __webpack_public_path__ + "img/vertical_4_3_6005.b4995c8c.png";